export function mountSimulator(importer, getProps) {
  const mount = () => {
    const domContainer = document.querySelector('#react-simulateur');
    if (!domContainer) {
      return;
    }

    const data = domContainer.getAttribute('data-props');
    const props = data ? JSON.parse(data) : {};

    Promise.all([import('react'), import('react-dom'), importer()])
      .then(([{ default: React }, { render }, { default: SimulateurVersion }]) => {
        render(React.createElement(SimulateurVersion, getProps(props)), domContainer);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('[simulator] failed to load lazy chunk', error);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
    return;
  }

  mount();
}
